import { Pipe, PipeTransform } from '@angular/core';
import { str2Date } from 'globals/helpers/helpers';

@Pipe({
    name: 'str2Date',
    standalone: true
})
export class Str2DatePipe implements PipeTransform {
  constructor() {}
  transform(dateId: string) {
    return str2Date(dateId)
  }
}

